/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core';
import {
    arrayOf, shape, string,
} from 'prop-types';
import React from 'react';
import FaqBlock from '../../GraphqlCategoryPage/Partials/FaqBlock/FaqBlock';
import FAQBlockV2 from './FAQBlockV2';

const useStyles = makeStyles((theme) => ({
    faqDefaultMainContainer: {
        width: '100%',
        maxWidth: '1400px',
        margin: '0 auto',
        [theme.breakpoints.down(1401)]: {
            padding: '0px 12px',
        },
    },
}));

const FAQBlockContainer = ({ faqData }) => {
    const classes = useStyles();

    if (Object.keys(faqData).length < 0) return null;
    const presentationStyle = faqData?.presentation_style;

    switch (presentationStyle) {
        case 'default':
            return (
                <div className={classes.faqDefaultMainContainer}>
                    <FaqBlock faqBlock={faqData} />
                </div>
            );
        case 'v2':
            return <FAQBlockV2 faqBlock={faqData} />;
        default:
            return (
                <div className={classes.faqDefaultMainContainer}>
                    <FaqBlock faqBlock={faqData} />
                </div>
            );
    }
};

FAQBlockContainer.propTypes = {
    faqData: shape({
        title: string,
        faqs: arrayOf(shape({
            answer: string,
            question: string,
        })),
    }),
};

FAQBlockContainer.defaultProps = {
    faqData: {},
};

export default FAQBlockContainer;
